export default __webpack_public_path__ + "static/media/mc.f1916538.svg";